// extracted by mini-css-extract-plugin
export default {"reactSelect":"CustomSelect_reactSelect__I4s3p"};